function SettingsServersCtrl($scope, $q, venueService, $state, organizationMemberService, managementUserService, organizationService, alertService,
  ERROR_MESSAGES, sdkUtils, loggerService, modalService, serverService) {
  const currentUserOrganization = organizationService.getCurrentOrganization();
  const currentUser = managementUserService.getCurrentUser();

  _initScope();

  $q.all([
      venueService.getCurrentVenues(),
      _getOrganizationStaffMembers()
    ])
    .then(results => {
      $scope.venues = results[0];
    });

  function _initScope() {
    $scope.loading = true;
    $scope.currentUser = currentUser;

    $scope.linkCopied = function(staffMember, $event) {
      if ($event) $event.preventDefault();

      staffMember.showCopiedTooltip = true;
    };

    $scope.staffFilterForm = {
      searchTerm: null
    };

    $scope.staffListDataTableOptions = {
      paginationType: 'full_numbers',
      displayLength: 50
    };

    $scope.staffDataTableInstance = {};

    $scope.filterStaffList = function filterStaffList() {
      if ($scope.staffDataTableInstance && $scope.staffDataTableInstance.DataTable) {
        $scope.staffDataTableInstance.DataTable.search($scope.staffFilterForm.searchTerm).draw();
      }
    };

    $scope.deleteStaffMember = _deleteStaffMember;
    $scope.canEditMember = _canEditMember;

    $scope.changeVenue = function(venue, $event) {
      if ($event) $event.preventDefault();

      $scope.selectedVenue = venue;
    };

    watchVenueChange();
  }

  function _getOrganizationStaffMembers() {
    const options = {
      type: 'SERVER'
    };

    if ($scope.selectedVenue) options.venueId = $scope.selectedVenue.id;

    $scope.loading = true;

    return serverService.listByOrganizationId(currentUserOrganization.id, options)
      .then(staffMembers => {
        $scope.staffMembers = staffMembers || [];
      })
      .catch(response => {
        const errorMsg = sdkUtils.getErrorFromResponse(response);

        if (errorMsg) loggerService.error(errorMsg);

        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_STAFF);
      })
      .finally(() => {
        $scope.loading = false;
      });
  }

  function _deleteStaffMember(staffMember, $event) {
    if (!staffMember) return;
    if ($event) $event.preventDefault();

    modalService.confirmation({
        modalHeader: `Delete Server ${staffMember.firstName} ${staffMember.lastName}`,
        modalMessage: 'Are you sure you want to delete this server?',
        confirmBtnTxt: 'Delete Server',
        confirmingBtnTxt: 'Deleting...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          organizationMemberService.deleteByIdAndOrganizationId(staffMember.id, currentUserOrganization.id)
            .then(() => {
              const index = $scope.staffMembers.indexOf(staffMember);

              $scope.staffMembers.splice(index, 1);

              alertService.success('Server deleted');
            })
            .catch(response => {
              alertService.error(sdkUtils.getErrorFromResponse(response));
            })
            .finally(() => {
              result.modalInstance.close();
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function _canEditMember(member) {
    return member &&
      member.managementUser !== currentUser.id &&
      !member.owner;
  }

  function watchVenueChange() {
    $scope.$watch('selectedVenue', (newVal, oldVal) => {
      if (newVal !== oldVal) {
        _getOrganizationStaffMembers();
      }
    });
  }
}

SettingsServersCtrl.$inject = [
  '$scope',
  '$q',
  'venueService',
  '$state',
  'jsSdk.server',
  'jsSdk.managementUser',
  'organizationService',
  'alertService',
  'ERROR_MESSAGES',
  'jsSdk.utils',
  'loggerService',
  'modalService',
  'jsSdk.server'
];

export default SettingsServersCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsServers/settingsServersCtrl.js